import { ComponentStyle } from '@/theme/styles.types.ts';

export const buttonStyles: ComponentStyle = {
	default:
		'active:scale-95 rounded-md select-none cursor-pointer box-border whitespace-nowrap duration-300 transition-[background-color,color,box-shadow,outline,border] focus:outline-none border-transparent border hover:border-transparent active:ring-4 relative',
	states: {
		disabled: 'opacity-50 pointer-events-none relative'
	},
	variants: {
		primary: 'text-white bg-primary-700 hover:bg-primary-800 active:ring-primary-200',
		secondary: 'text-neutral-400 bg-neutral-50 hover:text-neutral-500 hover:bg-neutral-100 active:ring-neutral-200',
		success: 'text-white bg-success-700 hover:bg-success-800 active:ring-success-200',
		error: 'text-white bg-error-600   hover:bg-error-700   active:ring-error-200',
		warning: 'text-white bg-warning-600 hover:bg-warning-500 active:ring-warning-200'
	},
	sizes: {
		base: 'py-2 px-4 text-sm',
		sm: 'px-2.5 py-2 text-xs',
		lg: 'px-6 py-3 text-base'
	}
};

export const outLinedButtonStyles: ComponentStyle = {
	default:
		'active:scale-95 rounded-md font-medium select-none cursor-pointer box-border whitespace-nowrap duration-300 transition-[background-color,color,box-shadow,outline,border] focus:outline-none',
	states: {
		disabled: 'opacity-30 grayscale border-neutral-400 cursor-not-allowed pointer-events-none'
	},
	variants: {
		primary: 'border-primary-700 border hover:bg-primary-700 text-primary-600 hover:text-white',
		secondary: 'border-neutral-700 border hover:bg-neutral-900 text-neutral-700 hover:text-white',
		error: 'border-error-600   border hover:bg-error-600 text-error-600   hover:text-white',
		success: 'border-success-600 border hover:bg-success-600 text-success-600 hover:text-white',
		warning: 'border-warning-500 border hover:bg-warning-500 text-warning-700 hover:text-white'
	},
	sizes: {
		base: 'py-2 px-4 text-sm',
		sm: 'px-2.5 py-2 text-xs',
		lg: 'px-6 py-3 text-base'
	}
};
